'use client';

interface Sayfa {
  id: number;
  baslik: string;
  slug: string;
  icerik: string;
  meta_aciklama?: string;
  aktif: boolean;
}

export default function CmsSayfasi({ sayfa }: { sayfa: Sayfa }) {
  return (
    <div className="min-h-screen bg-[var(--color-gray-50)]">
      <div className="bg-gradient-to-br from-[var(--color-primary)] to-[var(--color-primary-dark)] text-white">
        <div className="max-w-5xl mx-auto px-4 py-10 text-center">
          <h1 className="text-3xl md:text-4xl font-bold mb-2">{sayfa.baslik}</h1>
          {sayfa.meta_aciklama && (
            <p className="text-base text-blue-100 max-w-2xl mx-auto">{sayfa.meta_aciklama}</p>
          )}
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12">
          <div
            className="prose prose-gray max-w-none
              prose-headings:font-bold prose-headings:text-gray-800
              prose-p:text-gray-600 prose-p:leading-relaxed
              prose-ul:text-gray-600 prose-ol:text-gray-600
              prose-strong:text-gray-800
              prose-a:text-blue-600 prose-a:no-underline hover:prose-a:underline"
            dangerouslySetInnerHTML={{ __html: sayfa.icerik }}
          />
        </div>
      </div>
    </div>
  );
}